import React from 'react'
import { Button, Flex, Heading, Message, Modal, Text } from '@workwhile/ui'
import { useRemoveUserPermissionsFlowContextValue } from '../context/RemoveUserPermissionsFlowProvider'
import { useUserPermissionsWorkflowsContextValue } from '../../../context/UserPermissionsWorkflowsProvider'
import { RevokeTarget } from 'api/admin/userPermissions/types'
import { getPermissionName } from 'api/admin/userPermissions/permissions'
import { formatPrivilegeUserLabel } from '../../../utils'

export const RemoveUserPermissionsFlowMain = ({
  target,
}: {
  target: RevokeTarget
}) => {
  const {
    removeUserPermissionsFlow: { isOpen, close },
  } = useUserPermissionsWorkflowsContextValue()

  const {
    state: { isPending, errorMessage },
    actions: { confirm },
  } = useRemoveUserPermissionsFlowContextValue()

  const userLabel = formatPrivilegeUserLabel(target.user)
  const itemLabel =
    target.kind === 'permission'
      ? getPermissionName(target.permission)
      : target.label
  const title =
    target.kind === 'permission' ? 'Revoke permission' : 'Revoke company scope'
  const bodyPrefix =
    target.kind === 'permission' ? (
      <>
        Revoke <strong>{itemLabel}</strong> for <strong>{userLabel}</strong>?
      </>
    ) : (
      <>
        Revoke company scope <strong>{itemLabel}</strong> for{' '}
        <strong>{userLabel}</strong>?
      </>
    )

  return (
    <Modal
      open={isOpen}
      onClose={close}
      position="top"
      loading={isPending}
      customCta={
        <Flex>
          <Button variant="text" onClick={close}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={confirm}>
            Revoke
          </Button>
        </Flex>
      }
    >
      <Heading level={3} fontWeight="400" style={{ margin: 0 }}>
        {title}
      </Heading>
      <Text mt={3}>{bodyPrefix}</Text>

      {errorMessage ? (
        <Message variant="error" mt={3} borderRadius="small">
          {errorMessage}
        </Message>
      ) : null}
    </Modal>
  )
}
